import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectUser } from '../../state/auth/auth.selectors';
import { principalRouteNavigate } from '../../shared/utilities/const/route';

export const loginGuard: CanActivateFn = () => {
  const router = inject(Router);
  const store = inject(Store);
  const user = store.selectSignal(selectUser);

  if (user() === null) {
    return true;
  }

  router.navigateByUrl(principalRouteNavigate.verbalList);
  return false;
};
